<!-- 方案管理 -->
<!-- 表单 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <div class="page_content_top_line">
            <el-button type="primary" size="mini" @click="actionSet(buttonValue)"
               :disabled="buttonValue.actionType==0 && voucherInfo.configId == ''  ? true  : buttonValue.actionType==1 && voucherPlanList.length == 0 ? true : buttonValue.actionType==2 && voucherPlanList.length == 0 ? true : false"
               v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
               {{buttonValue.jurName}}
            </el-button>
            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
               刷新
            </el-button>
         </div>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="voucherInfo" class="demo-form-inline" size="mini">
               <el-form-item label="选择账套">
                  <el-select v-model="voucherInfo.configId" placeholder="请选择账套" filterable clearable @change="changeSel">
                     <el-option v-for="item in accountList" :key="item.configId" :label="item.configId" :value="item.configId"></el-option>
                  </el-select>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <el-card class="box-card" style="position: relative; overflow: hidden">
         <div class="page_content">
            <div class="page_content_top">
               <div class="page_content_top_line">
                  <h4 style="margin-top:0;">凭证方案设置</h4>
               </div>
            </div>
            <!-- <div class="page_content_center">
               <el-table v-if="pageShowData.jurTableVo" stripe :data="voucherPlanList" height="100%" border style="width: 100%" highlight-current-row size="mini">
                  <el-table-column label="选择操作" width="80">
                     <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                           <i class="el-icon-thumb"></i>
                        </el-radio>
                     </template>
                  </el-table-column>
                  <el-table-column v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                     :prop="tableValye.entityField" :label="tableValye.showField">
                     <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                           <span v-if="scope.row[tableValye.entityField]">
                              {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                           </span>
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                           {{scope.row.isWms == 0 ? '否' : '是'}}
                        </el-tag>
                        <span v-else-if="tableValye.isRift == 1">
                           <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">
                           {{$common.getIsGsp(tableValye.formatterContent,scope.row.woamState)}}</el-tag>
                        <span v-else>
                           {{scope.row[tableValye.entityField]}}
                        </span>
                     </template>
                  </el-table-column>
               </el-table>
            </div> -->
            <div class="page_content_center">
               <div class="dis">
                  <div class="right">
                     <el-table id="ta" :data="voucherPlanList" border height="500" size="mini" style="width: 100%;margin-top:10px;">
                        <el-table-column label="选择" width="80">
                           <template slot-scope="scope">
                              <el-radio v-model="mainSelectedDataIndex" :label="scope.$index" border size="mini">
                                 <i class="el-icon-thumb"></i>
                              </el-radio>
                           </template>
                        </el-table-column>
                        <el-table-column prop="planName" label="方案名称">
                        </el-table-column>
                        <el-table-column prop="configId" label="账套号">
                        </el-table-column>
                     </el-table>
                  </div>
               </div>
            </div>
         </div>
         <el-dialog top="1vh" :title="diaTitle+'凭证方案'" :visible.sync="voucherDia" width="80%">
            <el-form :model="voucherInfo" label-width="100px" class="demo-ruleForm deForm" size="mini">
               <div class="right-main" style="margin-top: 0px;">
                  <h4>方案名称</h4>
                  <el-form-item label-width="0px" style="margin-top:10px;">
                     <el-input type="text" v-model="voucherInfo.planName"></el-input>
                  </el-form-item>
               </div>
               <div class="right-main">
                  <h4>提取方案</h4>
                  <el-form-item label-width="0px" style="margin-top:10px;">
                     <el-input type="textarea" v-model="voucherInfo.planSql"></el-input>
                  </el-form-item>
               </div>
               <div class="right-main">
                  <div class="dis">
                     <h4>凭证明细</h4>
                     <el-row>
                        <el-tag @click="addVoucher" size="mini" style="cursor: pointer;margin-left:10px;">新增</el-tag>
                        <el-tag @click="deleteDetails" :disabled="voucherDetails.length == 0" type="danger" size="mini" style="cursor: pointer;margin-left:10px;">删除</el-tag>
                     </el-row>
                  </div>
                  <el-table id="ta" :data="voucherInfo.tvoucherDeatilDtoList" border height="280" size="mini" style="width: 100%;margin-top:10px;">
                     <el-table-column label="选择" width="66">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="borrowDirection" label="借贷方向(必选项)">
                        <template slot-scope="scope">
                           <el-form-item label-width="0px" size="mini">
                              <el-select v-model="scope.row.borrowDirection">
                                 <el-option label="借方" value="借方"></el-option>
                                 <el-option label="贷方" value="贷方"></el-option>
                              </el-select>
                           </el-form-item>
                        </template>
                     </el-table-column>
                     <el-table-column prop="detailSql" label="提取SQL">
                        <template slot-scope="scope">
                           <el-form-item label-width="0px" size="mini">
                              <el-input type="text" v-model="scope.row.detailSql"></el-input>
                           </el-form-item>
                        </template>
                     </el-table-column>
                     <el-table-column prop="remark" label="备注说明(必填项)">
                        <template slot-scope="scope">
                           <el-form-item label-width="0px" size="mini">
                              <el-input type="text" v-model="scope.row.remark"></el-input>
                           </el-form-item>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
               <div class="right-main">
                  <el-row :gutter="24">
                     <el-col :lg="6" :md="12" :sm="24">
                        <el-form-item label="含税金额字段" label-width="100px" style="margin-top:10px;">
                           <el-input type="text" v-model="voucherInfo.psmoney"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :lg="6" :md="12" :sm="24">
                        <el-form-item label="借方金额字段" label-width="100px" style="margin-top:10px;">
                           <el-input type="text" v-model="voucherInfo.debitMoney"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :lg="6" :md="12" :sm="24">
                        <el-form-item label="贷方金额字段" label-width="100px" style="margin-top:10px;">
                           <el-input type="text" v-model="voucherInfo.lenderMoney"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :lg="6" :md="12" :sm="24">
                        <el-form-item label="科目号字段" label-width="100px" style="margin-top:10px;">
                           <el-input type="text" v-model="voucherInfo.groupField"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="right-main">
                  <h5>成功回写</h5>
                  <el-form-item label-width="0px" style="margin-top:10px;">
                     <el-input type="textarea" v-model="voucherInfo.writeSql"></el-input>
                  </el-form-item>
               </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
               <el-button @click="voucherDia = false">取 消</el-button>
               <el-button type="primary" @click="saveVoucher()">确 定</el-button>
            </span>
         </el-dialog>
      </el-card>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import {mock} from "@/api/formList.js"
import Vue from "vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
      //这里存放数据
      return {
         dialogFormVisible: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "",
            actionType: 0, // 0新增，1修改
         },
         printform: {
            printName: "",
            printDesc: "",
            printContent: "",
         },
         tableData: [],
         systemFormList: [],
         selectForm: "",
         drawer: false,
         formData: {},
         classifyInfo: [],
         pageShowData: [],
         classifyType: [],
         defaultParams: {
            label: "jurName",
            value: "jurId",
            children: [],
         },
         classifySelValue: "",
         showData: {},
         drawerTitle: "",
         ids: [],
         allDataList: [],
         printDataUrl: "",
         userData: [],
         reportmod: "",
         idParams: {},
         operType: 0,
         loading: false,
         plan: "",
         voucherDia: false,
         accountList: [], // 所有账套
         configId: "", //选择的账套
         voucherInfo: {
            configId: "", //账套号
            debitMoney: "", // 借方金额字段
            groupField: "", // 科目号分组字段
            lenderMoney: "", //贷方金额字段
            planName: "", //方案名称
            planSql: "", //方案Sql
            psmoney: "", // 含税金额字段
            tvoucherDeatilDtoList: [
               //凭证明细
               {
                  borrowDirection: "", // 借贷方向
                  detailSql: "", // 提取sql
                  remark: "", //备注说明
               },
            ],
            writeSql: "", //回写sql
         },
         voucherDetails: [
            //凭证明细
            {
               borrowDirection: "",
               detailSql: "",
               remark: "",
            },
         ],
         defaultDetail: {
            //默认明细字段
            borrowDirection: "",
            detailSql: "",
            remark: "",
         },
         selectedDataIndex: 0,
         voucherPlanList: [],
         mainSelectedDataIndex: 0,
         diaType: 0,
         diaTitle: "",
         buttonList: [],
         multipleSelection: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      // 动作集合
      actionSet(actionData) {
         console.log(actionData);
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true;
               this.actionData = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: "",
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
                  type: "one",
               };
               this.addVoucherPlan(0);
               break;
            case 1:
               if (this.voucherPlanList.length <= 0) {
                  if (!dataInfo) {
                     this.$message({
                        message: "暂无数据",
                        type: "error",
                     });
                     return false;
                  }
               }
               var dataInfo = JSON.parse(
                  JSON.stringify(this.voucherPlanList[this.selectedDataIndex])
               );
               if (!dataInfo) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.addVoucherPlan(1);
               break;
            case 2:
               if (this.multipleSelection.length > 1) {
                  return this.$message({
                     message: "请选中一条数据删除",
                     type: "error",
                  });
               }
               this.delVoucherPlan();
               break;
            // 	break;
            // case 3:
            // 	this.submitData();
            // 	break;
            // case 15:
            // 	this.openFormDesign()
            // 	break;
         }
      },
      delVoucherPlan() {
         this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               let params = {
                  ids: [
                     this.voucherPlanList[this.mainSelectedDataIndex].planId,
                  ],
               };
               return new Promise((resolve, reject) => {
                  this.$http.delVoucherPlan(params).then((res) => {
                     if (res.status == 200) {
                        this.$message({
                           message: "删除成功",
                           type: "success",
                        });
                        this.queryVoucherPlan();
                     } else {
                        this.$message({
                           message: res.message,
                           type: "error",
                        });
                     }
                     resolve();
                  });
               });
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消删除",
               });
            });
      },
      changeSel() {
         this.queryVoucherPlan();
      },
      // 新增凭证方案
      addVoucherPlan(e) {
         this.diaType = e;
         console.log(this.diaType);
         if (e == 0) {
            for (let key in this.voucherInfo) {
               if (key != "configId") {
                  this.voucherInfo[key] = "";
               }
               if (key == "tvoucherDeatilDtoList") {
                  this.voucherInfo[key] = [];
                  this.voucherInfo[key].push(this.defaultDetail);
               }
            }
            this.diaTitle = "新增";
         } else {
            this.diaTitle = "修改";
            this.voucherInfo = this.voucherPlanList[this.mainSelectedDataIndex];
         }
         this.voucherDia = true;
      },
      // 保存新增凭证
      saveVoucher() {
         if (this.diaType == 0) {
            let params = this.voucherInfo;
            return new Promise((resolve, reject) => {
               this.$http.addVoucherPlan(params).then((res) => {
                  if (res.status == 200) {
                     this.voucherDia = false;
                     this.$message({
                        message: "新增成功",
                        type: "success",
                     });
                     this.queryVoucherPlan();
                  } else {
                     this.$message({
                        message: res.message,
                        type: "error",
                     });
                  }
                  resolve();
               });
            });
         } else {
            let params = this.voucherInfo;
            return new Promise((resolve, reject) => {
               this.$http.updateVoucherPlan(params).then((res) => {
                  if (res.status == 200) {
                     this.voucherDia = false;
                     this.$message({
                        message: "修改成功",
                        type: "success",
                     });
                     this.queryVoucherPlan();
                  } else {
                     this.$message({
                        message: res.message,
                        type: "error",
                     });
                  }
                  resolve();
               });
            });
         }
      },
      // 查询凭证方案
      queryVoucherPlan() {
         if (this.voucherInfo.configId == "") {
            let params = {
               configId: "",
            };
            return new Promise((resolve, reject) => {
               this.$http.getVoucherPlan(params).then((res) => {
                  if (res.status == 200) {
                     this.voucherPlanList = res.result;
                  } else {
                     this.$message({
                        message: res.message,
                        type: "error",
                     });
                  }
                  resolve();
               });
            });
         } else {
            let params = {
               configId: this.voucherInfo.configId,
            };
            return new Promise((resolve, reject) => {
               this.$http.getVoucherPlan(params).then((res) => {
                  if (res.status == 200) {
                     this.voucherPlanList = res.result;
                  } else {
                     this.$message({
                        message: res.message,
                        type: "error",
                     });
                  }
                  resolve();
               });
            });
         }
      },
      // 新增凭证明细
      addVoucher() {
         var dea = {
            //默认明细字段
            borrowDirection: "",
            detailSql: "",
            remark: "",
         };
         this.voucherInfo.tvoucherDeatilDtoList.push(dea);
      },
      // 删除明细
      deleteDetails() {
         this.$confirm("此操作将永久删除该明细, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.voucherInfo.tvoucherDeatilDtoList.splice(
                  this.selectedDataIndex,
                  1
               );
               this.selectedDataIndex = 0;
               this.$message({
                  type: "success",
                  message: "删除成功",
               });
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消删除",
               });
            });
      },
      // 获取全部账套信息
      getAllAccountInfo() {
         return new Promise((resolve, reject) => {
            this.$http.getAccountInfo().then((res) => {
               this.accountList = res.result;
               console.log(res);
               resolve();
            });
         });
      },

      // 查询条件删除一行
      delAccount(index, rows) {
         if (rows.length === 1) {
            return this.$message({
               message: "此项不可删除",
               type: "warning",
            });
         }
         rows.splice(index, 1);
      },

      submitForm(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               alert("submit!");
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
      resetForm(formName) {
         this.$refs[formName].resetFields();
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         
      },
// 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            this.getAllAccountInfo();
            this.queryVoucherPlan();
            this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getAllAccountInfo();
      this.queryVoucherPlan();
      this.getButtonList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {},
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.el-tabs__content {
   height: 90% !important;
}
.el-card {
   min-height: 70vh;
   margin: 20px;
}
.el-tabs-box {
   margin-top: 20px;
}
/* .page_content_top_line {
    margin-top: 20px;
} */
.draw {
   padding: 20px;
}
.el-tabs__content {
   min-height: 60vh;
}
.el-select {
   width: 100%;
}
::v-deep #addNew .el-table__row td:last-child {
   border: none;
}
/* ::v-deep#addNew .el-table {
    max-height: 70vh !important;
    width: 100%;
    overflow-y: auto;
    overflow-x: auto;
}
::v-deep#addNew .el-table__body-wrapper {
    max-height: 100vh !important;
} */
.listForm {
   border: 1px solid #efefef;
   padding: 10px;
   margin-bottom: 10px;
}
.btns {
   display: flex;
   justify-content: center;
}
.left {
   min-width: 200px;
}
.left ul li {
   list-style-type: none;
   padding: 5px;
   border-top: 1px solid rgba(160, 158, 158, 0.255);
   font-size: 14px;
}
.dis {
   display: flex;
   align-items: center;
}
h5 {
   margin: 0;
}
.deForm {
   width: 100%;
}
.right {
   width: 100%;
}
.right-main {
   margin-top: 10px;
}
#ta .el-form-item--mini.el-form-item {
   margin-bottom: 0;
}
::v-deep .el-dialog__body {
   padding-top: 10px;
}
h4 {
   margin: 0;
}
.el-radio--mini.is-bordered {
   padding: 3px 4px 0 5px;
   border-radius: 3px;
   height: 22px;
}
</style>
